import { useQuery } from 'react-query';
import { useZoneContext } from '../../../../contexts/useZoneContext';

export const useGetBestFitCasesKey = 'get-best-fit-cases';

export const useGetBestFitCases = (enabled: boolean, caseGuid?: string) => {
    const { zoneApiClient } = useZoneContext();
    
    return useQuery({
        queryKey: [useGetBestFitCasesKey, caseGuid],
        queryFn: async () => {
            const response = await zoneApiClient.getCaseAssessmentBestFitCases(caseGuid ?? '');

            if (response.httpResponse.status === 500) {
                throw new Error('Failed to retrieve the best fit cases for this case.');
            }
            return response.payload;
        },
        enabled: enabled && !!caseGuid,
        cacheTime: Infinity,
        staleTime: Infinity
    });
}